import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { ModuleManager } from 'src/shared/models/module-manager';
import { ModuleManagerSetting } from 'src/shared/models/module-manager/module-manager-setting.model';
import { ViewByDropDownOptions } from '../../modules/quality-score/quality-score.model';
import { QualityScoreService } from '../../modules/quality-score/quality-score.service';

@Component({
    selector: 'cv-quality-score-settings',
    templateUrl: './quality-score-settings.component.html',
    styleUrls: ['./quality-score-settings.component.scss']
})
export class QualityScoreSettingsComponent implements OnInit, OnDestroy {

    @Input() moduleManager: ModuleManager;

    definitions: ViewByDropDownOptions[];
    showViewBy = {};
    openModalWidgetKey: string;
    selectedView: ViewByDropDownOptions;
    selectedViewName = '';

    settings = {
        rangeValues: [70, 90],
        defaultPoints: [70, 90],
    };

    // For additional filters - should match the metric pulls in the quality score controller
    selectedMetrics = [15137, 15135];

    //For cxone range slider
    points = [0, 100];
    connect = [true, true, true];
    chosenValues = [];
    private viewBySubscription: Subscription;
    private openModalSubscription: Subscription;


    constructor(
        private cvLocalizationService: CVLocalizationService,
        private qualityScoreService: QualityScoreService,
    ) { }

    ngOnInit(): void {
        this.definitions = [
            {
                setValue: 'Teams',
                displayName: this.cvLocalizationService.getCachedText('Quality_Score_Module', 'Teams', 'Teams')
            },
            {
                setValue: 'Agents',
                displayName: this.cvLocalizationService.getCachedText('Quality_Score_Module', 'Agents', 'Agents')
            }
        ];

        this.selectedView = this.definitions[0];

        this.moduleManager.addSetting({
            name: 'RangePoints',
            getValue: () => this.settings.rangeValues,
            onSettingLoaded: values => {
                this.settings.rangeValues = values;
                if (!values)
                    this.settings.rangeValues = this.settings.defaultPoints;
            },
            defaultValue: this.settings.defaultPoints,
        });

        this.moduleManager.addSetting({
            name: 'SelectedView',
            required: true,
            getValue: () => this.selectedViewName,
            onSettingLoaded: (value) => {
                if (!value) return;

                this.selectedViewName = value;
                if (this.definitions.length) {
                    this.selectedView = this.definitions.find(rs => rs.setValue === value);
                }
            },
            defaultValue: 'Teams',
        } as ModuleManagerSetting<string>);

        this.viewBySubscription = this.qualityScoreService.state$.subscribe(state => this.showViewBy = state);
        this.openModalSubscription = this.moduleManager.slideoutSettingsManager.subscribe(() => this.openModalWidgetKey = this.moduleManager.getModuleKey());

        this.moduleManager.customSettingsAdded = true;
    }

    ngOnDestroy() {
        if (this.viewBySubscription) {
            this.viewBySubscription.unsubscribe();
        }
        if (this.openModalSubscription) {
            this.openModalSubscription.unsubscribe();
        }
    }

    onViewSelected() {
        this.selectedViewName = this.selectedView?.setValue || '';
    }
}
